import { FormikHelpers, FormikValues } from 'formik';
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { object, string } from 'yup';

import Botao from 'Component/Botao';
import BotaoLink from 'Component/BotaoLink';
import Buscando from 'Component/Buscando';
import Cabecalho from 'Component/Cabecalho';
import Form, { Campo } from 'Component/Form';
import LayoutDefault from 'Component/Layout';
import Paginacao from 'Component/Paginacao';
import SemRegistros from 'Component/SemRegistros';
import { UniformeLista } from 'Component/Uniforme';
import Parametros from 'Interface/Requisicao';
import { useRecuperarUniformesQuery } from 'View/Service/Default/Uniformes';

const regras = object({
  busca: string().optional().min(3, 'Deve ter mais que 3 letras'),
});

const Default = (): React.ReactElement => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { data, refetch, isFetching, isLoading } = useRecuperarUniformesQuery({
    page: searchParams.get('pagina') || 1,
    options: { busca: { termo: searchParams.get('busca') || '' } },
    sort: 'nome',
  } as Parametros);

  const filtrar = (
    dados: { busca: string },
    form: FormikHelpers<FormikValues>
  ) => {
    searchParams.set('busca', dados.busca);
    searchParams.set('pagina', '1');

    setSearchParams(searchParams);

    form.setSubmitting(false);
  };

  return (
    <LayoutDefault>
      <Cabecalho
        titulo="Uniformes"
        descricao="Listagem de uniformes cadastrados no banco de dados"
      />
      <Form
        emLinha
        onSubmit={filtrar}
        regras={regras}
        desabilitado={isFetching}
      >
        <div className="row">
          <div className="col-md-6 mb-3">
            <Botao icone="arrow-clockwise" onClick={refetch} className="me-2" />
            <BotaoLink tema="success" icone="plus-lg" to="/uniformes/adicionar">
              Adicionar
            </BotaoLink>
          </div>
          <div className="col-md-6 mb-3">
            <div className="hstack gap-3">
              <Campo name="busca" rotulo="Digite o que deseja buscar" />
              <Botao type="submit" icone="filter" />
            </div>
          </div>
        </div>
      </Form>
      <Buscando exibir={isLoading} />
      <SemRegistros
        carregando={isLoading}
        registros={data?.uniformes.length}
        redirecionar="/uniformes/adicionar"
      />
      <div className="bg-white shadow-sm rounded">
        {data?.uniformes?.map((uniforme) => (
          <UniformeLista
            key={`${uniforme.id}-${uniforme.modificado}`}
            dados={uniforme}
          />
        ))}
      </div>
      <Paginacao dados={data?.paginacao} desabilitado={isFetching} />
    </LayoutDefault>
  );
};

export default Default;
